import { ColorsConfig } from '@ddt-web/config';
import { ColorFormatter, ColumnConfig, CombinedPortfoliosGridExtractorConfig, CombinedPortfoliosGridExtractorConfigOptions, LabelFormatter, LodashExtractor, LodashSeriesEnricherMapper, NumberFormatter, TabConfig } from '@ddt-web/data-service';

import { HOLDINGS_ENRICHER, MODEL_HOLDINGS_COLUMN_CONFIG } from './family-column.config';

export const MODEL_HOLDINGS_CHART = new TabConfig(
	'holdings.chart',
	null,
	CombinedPortfoliosGridExtractorConfig.create({
		mapper: new LodashSeriesEnricherMapper(['familyHoldings', 'positionDetails'], ['familyHoldings', 'positionDetails'], 'familyHoldings.components', HOLDINGS_ENRICHER),
		portfolioName: MODEL_HOLDINGS_COLUMN_CONFIG,
		category: ColumnConfig.create({
			id: 'assetClass',
			extractor: new LodashExtractor('formattedAcAssetClass', 'Other'),
			formatters: [
				new ColorFormatter(ColorsConfig.ASSET_CLASS_COLORS)
			],
			labelFormatter: new LabelFormatter('HOLDINGS_CHART')
		}),
		value: ColumnConfig.create({ id: 'weight', extractor: new LodashExtractor('weight', 0), labelFormatter: new NumberFormatter(NumberFormatter.PERCENT) })
	} as CombinedPortfoliosGridExtractorConfigOptions)
);
